import {
  ADD_ACCOUNTS,
  REMOVE_ACCOUNT,
  REMOVE_ACCOUNTS,
} from "../../constants/reduxConstants";

const initialState = {
  accounts: [],
};
export const addAccountsReducer = (state = initialState, { payload, type }) => {
  switch (type) {
    case ADD_ACCOUNTS:
      return {
        ...state,
        accounts: [...state.accounts, ...payload],
      };
    case REMOVE_ACCOUNTS:
      return {
        ...state,
        accounts: [],
      };
    case REMOVE_ACCOUNT:
      let newArr = state.accounts.filter((obj, i) => i !== payload);
      return {
        ...state,
        accounts: [...newArr],
      };
    default:
      return state;
  }
};
